import 'twin.macro';
import React from 'react';
import {
  removeItemAtIndex,
  replaceItemAtIndex,
} from '@teetsh/app/src/utils/listMethods';
import Input from '@teetsh/app/src/components/Form/Input2';
import DynamicList, {
  useDynamicListContext,
} from '@teetsh/app/src/components/DynamicList';

interface Props {
  onChange: (v: string[]) => void;
  items: string[];
  inline?: boolean;
}

function SimpleInput(props: {
  onChange: (v: string[]) => void;
  items: string[];
}) {
  const p = useDynamicListContext();
  if (!p) {
    return null;
  }
  const { item, index } = p;
  return (
    <Input
      tw="mb-0"
      id={`item-${index}`}
      onChange={v =>
        props.onChange(
          replaceItemAtIndex(props.items, v?.currentTarget?.value || '', index),
        )
      }
      value={item}
    />
  );
}

export default function ListInputs(props: Props) {
  const { items, onChange, inline } = props;
  return (
    <DynamicList<string>
      inline={inline}
      items={items}
      onRemove={index => onChange(removeItemAtIndex(items, index))}
      onAdd={() => onChange([...items, ''])}
    >
      <SimpleInput onChange={onChange} items={items} />
    </DynamicList>
  );
}
